import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, HeightRule, SimpleField, footerTable, TextRun, convertInchesToTwip, Table, NumberFormat, PageNumber, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import './Assitance.css';
import Points from "./Points";
import Ratio from "./Ratio";
import { API_URL } from "./API";

const Assitance = ({ initialData, goBackToPolarity, projectId, selectedCore, generalData, ratioData, windingPolarityData, assistanceData, onSave, projectData }) => {

  const [selectedCores, setSelectedCores] = useState(() => {
    const isFormCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isFormCompleted === 'true') {
      localStorage.removeItem('assistanceFormCompleted');
      return selectedCore ? selectedCore.toString() : '1';
    }

    const savedCores = localStorage.getItem('selectedRatioCores');
    return savedCores || (selectedCore ? selectedCore.toString() : '1');
  });

  const [currentPage, setCurrentPage] = useState(() => {
    const isFormCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isFormCompleted === 'true') {
      return 'ratioTest';
    }

    const savedPage = localStorage.getItem('transformerRatioTestPage');
    return savedPage || 'ratioTest';
  });



  const [coreRatios, setCoreRatios] = useState(() => {
    const isFormCompleted = localStorage.getItem('assistanceFormCompleted');

    if (isFormCompleted === 'true') {
      const initialRatios = {};
      const numCores = parseInt(selectedCore?.toString() || '1');
      for (let i = 1; i <= numCores; i++) {
        initialRatios[i] = {
          ratioValue: '',
          primaryValue: '',
          secondaryValue: ''
        };
      }
      return initialRatios;
    }

    const savedRatios = localStorage.getItem('transformerCoreRatios');
    if (savedRatios) {
      return JSON.parse(savedRatios);
    }

    const ctFormData = localStorage.getItem('ctFormData');
    if (ctFormData) {
      try {
        const parsedFormData = JSON.parse(ctFormData);
        if (parsedFormData.coreDetails && Array.isArray(parsedFormData.coreDetails)) {
          const initialRatios = {};
          const numCores = parseInt(selectedCore?.toString() || '1');

          for (let i = 1; i <= numCores; i++) {
            const coreDetail = parsedFormData.coreDetails[i - 1];
            let ratioValue = '';
            let primaryValue = '';
            let secondaryValue = '';

            if (coreDetail && coreDetail.ratio && coreDetail.ratio.trim() !== '') {
              ratioValue = coreDetail.ratio.includes('/') ? coreDetail.ratio : `${coreDetail.ratio}/1A`;
              const [primary, secondary] = ratioValue.split('/');
              primaryValue = primary;
              secondaryValue = secondary.replace('A', '');
            }

            initialRatios[i] = {
              ratioValue: ratioValue,
              primaryValue: primaryValue,
              secondaryValue: secondaryValue
            };
          }
          return initialRatios;
        }
      } catch (error) {
       
      }
    }

    const initialRatios = {};
    const numCores = parseInt(selectedCore?.toString() || '1');
    for (let i = 1; i <= numCores; i++) {
      initialRatios[i] = {
        ratioValue: '',
        primaryValue: '',
        secondaryValue: ''
      };
    }
    return initialRatios;
  });


  useEffect(() => {
    const ctFormData = localStorage.getItem('ctFormData');
    if (ctFormData) {
      try {
        const parsedFormData = JSON.parse(ctFormData);
        if (parsedFormData.coreDetails && Array.isArray(parsedFormData.coreDetails)) {
          const numCores = parseInt(selectedCore?.toString() || '1');

          setCoreRatios(prev => {
            const updated = {};
            for (let i = 1; i <= numCores; i++) {
              const coreDetail = parsedFormData.coreDetails[i - 1];

              if (coreDetail && coreDetail.ratio && coreDetail.ratio.trim() !== '') {
                let ratioValue = coreDetail.ratio.includes('/') ? coreDetail.ratio : `${coreDetail.ratio}/1A`;
                const [primary, secondary] = ratioValue.split('/');

                updated[i] = {
                  ratioValue: ratioValue,
                  primaryValue: primary,
                  secondaryValue: secondary.replace('A', '')
                };
              } else {
                updated[i] = {
                  ratioValue: '',
                  primaryValue: '',
                  secondaryValue: ''
                };
              }
            }
            return updated;
          });
        }
      } catch (error) {
       
      }
    }
  }, [selectedCore]);



  useEffect(() => {

  const syncCoreRatiosFromCTForm = () => {
    const ctFormData = localStorage.getItem('ctFormData');
    if (ctFormData) {
      try {
        const parsedFormData = JSON.parse(ctFormData);
        if (parsedFormData.coreDetails && Array.isArray(parsedFormData.coreDetails)) {
          const numCores = parseInt(selectedCore?.toString() || selectedCores || '1');

          setCoreRatios(prev => {
            const updated = {};
            let hasChanges = false;

            for (let i = 1; i <= numCores; i++) {
              const coreDetail = parsedFormData.coreDetails[i - 1];
              let ratioValue = '';
              let primaryValue = '';
              let secondaryValue = '';

              if (coreDetail && coreDetail.ratio && coreDetail.ratio.trim() !== '') {
                ratioValue = coreDetail.ratio.includes('/') 
                  ? coreDetail.ratio 
                  : `${coreDetail.ratio}/1A`;
                const [primary, secondary] = ratioValue.split('/');
                primaryValue = primary;
                secondaryValue = secondary.replace('A', '');

                if (!prev[i] || 
                    prev[i].ratioValue !== ratioValue || 
                    prev[i].primaryValue !== primaryValue || 
                    prev[i].secondaryValue !== secondaryValue) {
                  hasChanges = true;
                }
              } else {
                ratioValue = '';
                primaryValue = '';
                secondaryValue = '';
              }

              updated[i] = {
                ratioValue: ratioValue,
                primaryValue: primaryValue,
                secondaryValue: secondaryValue
              };
            }

           
            if (hasChanges) {
              return updated;
            }
            return prev;
          });
        }
      } catch (error) {
        console.error('Error syncing core ratios:', error);
      }
    }
  };

 
  syncCoreRatiosFromCTForm();


  const intervalId = setInterval(syncCoreRatiosFromCTForm, 500);


  const handleStorageChange = (e) => {
    if (e.key === 'ctFormData') {
      syncCoreRatiosFromCTForm();
    }
  };

  window.addEventListener('storage', handleStorageChange);

  return () => {
    clearInterval(intervalId);
    window.removeEventListener('storage', handleStorageChange);
  };
}, [selectedCore, selectedCores]);



useEffect(() => {

  const numCores = parseInt(selectedCore?.toString() || selectedCores || '1');
  
  for (let coreNumber = 1; coreNumber <= numCores; coreNumber++) {
    const coreRatio = coreRatios[coreNumber];
    
    if (coreRatio && coreRatio.primaryValue && coreRatio.secondaryValue) {
      const primary = coreRatio.primaryValue;
      const secondary = coreRatio.secondaryValue;

      setForm(prevForm => {
        const testKey = `ratioTest${coreNumber}`;
        
        if (!prevForm[testKey]) {
          return prevForm;
        }

        const updatedForm = {
          ...prevForm,
          [testKey]: {
            ...prevForm[testKey],
            appliedCurrent: { ...prevForm[testKey].appliedCurrent },
            measuredCurrent: { ...prevForm[testKey].measuredCurrent }
          }
        };

        
        ['25%', '50%', '75%', '100%'].forEach(percentage => {
          updatedForm[testKey].appliedCurrent[percentage] = {
            ...prevForm[testKey].appliedCurrent[percentage]
          };
          updatedForm[testKey].measuredCurrent[percentage] = {
            ...prevForm[testKey].measuredCurrent[percentage]
          };

          ['R', 'Y', 'B'].forEach(phase => {
           
            const calculatedValue = calculateAppliedCurrent(primary, percentage);
            updatedForm[testKey].appliedCurrent[percentage][phase] = calculatedValue;

           
            const measuredValue = updatedForm[testKey].measuredCurrent[percentage][phase];
            if (measuredValue) {
              updatedForm[testKey].measuredCurrent[percentage][`${phase}Error`] =
                calculatePercentageError(measuredValue, calculatedValue, primary, secondary);
            }
          });
        });

        return updatedForm;
      });
    }
  }
}, [coreRatios, selectedCore, selectedCores]);


  const [form, setForm] = useState(() => {
    const isFormCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isFormCompleted === 'true') {
      return initialData ? JSON.parse(JSON.stringify(initialData)) : getDefaultFormData();
    }

    if (initialData) {

      return JSON.parse(JSON.stringify(initialData));
    }

    const savedData = localStorage.getItem('transformerRatioTestData');
    if (savedData) {

      const parsed = JSON.parse(savedData);

      const defaultData = getDefaultFormData();
      return {
        ...defaultData,
        ...parsed,

        ratioTest1: parsed.ratioTest1 || defaultData.ratioTest1,
        ratioTest2: parsed.ratioTest2 || defaultData.ratioTest2,
        ratioTest3: parsed.ratioTest3 || defaultData.ratioTest3,
        ratioTest4: parsed.ratioTest4 || defaultData.ratioTest4,
        ratioTest5: parsed.ratioTest5 || defaultData.ratioTest5
      };
    }

    return getDefaultFormData();
  });


  useEffect(() => {
    try {
      const localNavbarData = localStorage.getItem('navbarData');
      const localProjectData = localStorage.getItem('createReportData');

      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }

      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || parsedProjectData.subProjectName || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }
    } catch (error) {
     
      setErrorMessage("Failed to load saved data");
    }
  }, []);

  useEffect(() => {
    if (initialData) {

      setForm(JSON.parse(JSON.stringify(initialData)));
    }
  }, [initialData]);

  const [checklistData, setChecklistData] = useState(() => {
    const savedChecklist = localStorage.getItem('ctChecklistData');
    if (savedChecklist) {
      return JSON.parse(savedChecklist);
    }
    return {
      'ASS-00': 'OK',
      'ASS-01': 'OK',
      'ASS-02': 'OK',
      'ASS-03': 'OK',
      'ASS-04': 'OK',
      'ASS-05': 'OK'
    };
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [shouldShowKneePoint, setShouldShowKneePoint] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);


  const [formDownloaded, setFormDownloaded] = useState(() => {
    const isDownloaded = localStorage.getItem('assistanceFormDownloaded');
    return isDownloaded === 'true';
  });

  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [circuitBreakerData, setCircuitBreakerData] = useState({});
  const [testData, setTestData] = useState({});
  const [contactData, setContactData] = useState({});
  const [testFormData, setTestFormData] = useState({});
  const [testGeneralData, setTestGeneralData] = useState({});
  const [testRatioData, setTestRatioData] = useState({});

  function getDefaultFormData() {

    const createDefaultTest = () => ({
      appliedCurrent: {
        '25%': { R: '', Y: '', B: '' },
        '50%': { R: '', Y: '', B: '' },
        '75%': { R: '', Y: '', B: '' },
        '100%': { R: '', Y: '', B: '' }
      },
      measuredCurrent: {
        '25%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
        '50%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
        '75%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
        '100%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' }
      }
    });

    return {
      ratioTest1: createDefaultTest(),
      ratioTest2: createDefaultTest(),
      ratioTest3: createDefaultTest(),
      ratioTest4: createDefaultTest(),
      ratioTest5: createDefaultTest(),
      errors: {
        ratioTests: {}
      }
    };
  }

  const RESET_EVENT_NAME = 'ctReportDataCleared';
  const CLEAR_DATA_EVENT_NAME = 'ctReportDataClearedNoRedirect';


  const clearAllStorageData = () => {
    try {
      const keysToRemove = [
        'transformerRatioTestData',
        'transformerCoreRatios',
        'selectedRatioCores',
        'transformerRatioTestPage',
        'assistanceData',
        'ratioData',
        'windingPolarityData',
        'transformerWindingPolarityData',
        'ct_report_data',
        'observations',
        'recommendations',
        'ctFormData',
        'ctGeneralData',
        'navbarData',
        'createReportData',
        'pointsData',
        'kneePointData',
        'assistanceTestReportWord',
        'assistanceFormCompleted',
        'assistanceFormDownloaded',
        'assistanceFormSubmitted',
        'ct_test_data',
        'ct_general_data',
        'ct_ratio_data',
        'ct_polarity_data',
        'ct_points_data',
        'ct_knee_point_data',
        'assistance_autosave',
        'ctChecklistData'
      ];

      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });

    } catch (error) {
      
    }
  };




  const resetAllFormStates = () => {
    setForm(getDefaultFormData());

    const initialRatios = {};
    const numCores = parseInt(selectedCore?.toString() || '1');
    for (let i = 1; i <= numCores; i++) {
      initialRatios[i] = {
        ratioValue: '',
        primaryValue: '',
        secondaryValue: ''
      };
    }
    setCoreRatios(initialRatios);

    setSelectedCores('1');
    setCurrentPage('ratioTest');
    setIsFormSubmitted(false);
    setFormSubmitted(false);
    setFormDownloaded(false);
    setErrorMessage('');
    setCircuitBreakerData({});
    setTestData({});
    setContactData({});
    setTestFormData({});
    setTestGeneralData({});
    setTestRatioData({});
    setChecklistData({
      'ASS-00': 'OK',
      'ASS-01': 'OK',
      'ASS-02': 'OK',
      'ASS-03': 'OK',
      'ASS-04': 'OK',
      'ASS-05': 'OK'
    });
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });
  };


  useEffect(() => {
    const handlePageLoad = () => {
      const isFormCompleted = localStorage.getItem('assistanceFormCompleted');
      const isFormDownloaded = localStorage.getItem('assistanceFormDownloaded');

      if (isFormCompleted === 'true' || isFormDownloaded === 'true') {
     
        clearAllStorageData();
        resetAllFormStates();
      }
    };

    handlePageLoad();

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        handlePageLoad();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formSubmitted && formDownloaded) {
        localStorage.setItem('assistanceFormCompleted', 'true');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [formSubmitted, formDownloaded]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleGlobalReset = () => {
      clearAllStorageData();
      resetAllFormStates();
    };

    window.addEventListener(RESET_EVENT_NAME, handleGlobalReset);
    return () => {
      window.removeEventListener(RESET_EVENT_NAME, handleGlobalReset);
    };
  }, []);

  const loadFormDataSafely = (key, defaultValue = {}) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : defaultValue;
    } catch (error) {
  
      return defaultValue;
    }
  };

  const ensureDictFormat = (data, keyPrefix = 'item') => {
    if (Array.isArray(data)) {
      const dict = {};
      data.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          Object.keys(item).forEach(key => {
            dict[`${keyPrefix}_${index}_${key}`] = item[key];
          });
        } else {
          dict[`${keyPrefix}_${index}`] = item;
        }
      });
      return dict;
    } else if (typeof data === 'object' && data !== null) {
      return data;
    } else {
      return { value: data };
    }
  };

  const loadAllFormDataFromStorage = () => {
    try {
      const allData = {
        general: loadFormDataSafely('ct_report_data', {}),
        assistanceData: loadFormDataSafely('assistanceData', {}),
        ratioData: loadFormDataSafely('ratioData', {}),
        windingPolarityData: loadFormDataSafely('windingPolarityData', {}),
        coreRatios: loadFormDataSafely('transformerCoreRatios', {}),
        observations: loadFormDataSafely('observations', {}),
        recommendations: loadFormDataSafely('recommendations', {}),
        pointsData: loadFormDataSafely('pointsData', {}),
        kneePointData: loadFormDataSafely('kneePointData', {}),
        navbarData: loadFormDataSafely('navbarData', {}),
        createReportData: loadFormDataSafely('createReportData', {}),
        checklistData: loadFormDataSafely('ctChecklistData', checklistData)
      };

      return {
        general: ensureDictFormat({ ...allData.general, ...generalData }, 'general'),
        assistanceData: ensureDictFormat({ ...allData.assistanceData, ...assistanceData }, 'assistance'),
        ratioData: ensureDictFormat({ ...allData.ratioData, ...ratioData, ...form }, 'ratio'),
        windingPolarityData: ensureDictFormat({ ...allData.windingPolarityData, ...windingPolarityData }, 'polarity'),
        coreRatios: ensureDictFormat({ ...allData.coreRatios, ...coreRatios }, 'core'),
        observations: ensureDictFormat(allData.observations, 'observation'),
        recommendations: ensureDictFormat(allData.recommendations, 'recommendation'),
        pointsData: ensureDictFormat(allData.pointsData, 'points'),
        kneePointData: ensureDictFormat(allData.kneePointData, 'knee'),
        navbarData: ensureDictFormat(allData.navbarData, 'navbar'),
        createReportData: ensureDictFormat(allData.createReportData, 'create_report'),
        checklistData: allData.checklistData
      };
    } catch (error) {
      
      return {
        general: ensureDictFormat(generalData || {}, 'general'),
        assistanceData: ensureDictFormat(assistanceData || {}, 'assistance'),
        ratioData: ensureDictFormat({ ...ratioData, ...form } || {}, 'ratio'),
        windingPolarityData: ensureDictFormat(windingPolarityData || {}, 'polarity'),
        coreRatios: ensureDictFormat(coreRatios || {}, 'core'),
        observations: ensureDictFormat({}, 'observation'),
        recommendations: ensureDictFormat({}, 'recommendation'),
        pointsData: ensureDictFormat({}, 'points'),
        kneePointData: ensureDictFormat({}, 'knee'),
        navbarData: ensureDictFormat({}, 'navbar'),
        createReportData: ensureDictFormat({}, 'create_report'),
        checklistData: checklistData
      };
    }
  };

  useEffect(() => {
    const autoSave = () => {
      try {
        const formDataToSave = {
          form: form,
          coreRatios: coreRatios,
          selectedCores: selectedCores,
          currentPage: currentPage,
          projectDetails: projectDetails,
          checklistData: checklistData,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('assistance_autosave', JSON.stringify(formDataToSave));
      } catch (error) {
        
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000);

    return () => clearInterval(autoSaveInterval);
  }, [form, coreRatios, selectedCores, currentPage, projectDetails, checklistData]);

  useEffect(() => {
    if (initialData) {
      return;
    }

    try {
      const autoSavedData = localStorage.getItem('assistance_autosave');
      if (autoSavedData) {
        const parsedData = JSON.parse(autoSavedData);
        if (parsedData.form) {
          setForm(parsedData.form);
        }
        if (parsedData.coreRatios) {
          setCoreRatios(parsedData.coreRatios);
        }
        if (parsedData.selectedCores) {
          setSelectedCores(parsedData.selectedCores);
        }
        if (parsedData.currentPage) {
          setCurrentPage(parsedData.currentPage);
        }
        if (parsedData.projectDetails) {
          setProjectDetails(prev => ({
            ...prev,
            ...parsedData.projectDetails
          }));
        }
        if (parsedData.checklistData) {
          setChecklistData(parsedData.checklistData);
        }
      }
    } catch (error) {
     
    }
  }, [initialData]);

  useEffect(() => {
    const isCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isCompleted !== 'true') {
      localStorage.setItem('transformerCoreRatios', JSON.stringify(coreRatios));
    }
  }, [coreRatios]);

  useEffect(() => {
    const isCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isCompleted !== 'true') {
      localStorage.setItem('transformerRatioTestData', JSON.stringify(form));
    }
  }, [form]);

  useEffect(() => {
    const isCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isCompleted !== 'true') {
      localStorage.setItem('selectedRatioCores', selectedCores);
    }
  }, [selectedCores]);

  useEffect(() => {
    const isCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isCompleted !== 'true') {
      localStorage.setItem('transformerRatioTestPage', currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    const isCompleted = localStorage.getItem('assistanceFormCompleted');
    if (isCompleted !== 'true') {
      localStorage.setItem('ctChecklistData', JSON.stringify(checklistData));
    }
  }, [checklistData]);



  useEffect(() => {
    if (selectedCore) {
      const numCores = parseInt(selectedCore.toString());
      setSelectedCores(selectedCore.toString());

      const ctFormData = localStorage.getItem('ctFormData');
      let formCoreDetails = null;
      if (ctFormData) {
        try {
          const parsedFormData = JSON.parse(ctFormData);
          formCoreDetails = parsedFormData.coreDetails;
        } catch (error) {
         
        }
      }

      setCoreRatios(prev => {
        const updated = {};
        for (let i = 1; i <= numCores; i++) {
          let ratioValue = '';
          let primaryValue = '';
          let secondaryValue = '';

          if (formCoreDetails && formCoreDetails[i - 1] && formCoreDetails[i - 1].ratio && formCoreDetails[i - 1].ratio.trim() !== '') {
            ratioValue = formCoreDetails[i - 1].ratio.includes('/') ? formCoreDetails[i - 1].ratio : `${formCoreDetails[i - 1].ratio}/1A`;
            const [primary, secondary] = ratioValue.split('/');
            primaryValue = primary;
            secondaryValue = secondary.replace('A', '');
          }

          updated[i] = {
            ratioValue: ratioValue,
            primaryValue: primaryValue,
            secondaryValue: secondaryValue
          };
        }
        return updated;
      });

      setForm(prev => {
        const updated = { ...prev };
        for (let i = 1; i <= numCores; i++) {
          if (!updated[`ratioTest${i}`]) {
            updated[`ratioTest${i}`] = {
              appliedCurrent: {
                '25%': { R: '', Y: '', B: '' },
                '50%': { R: '', Y: '', B: '' },
                '75%': { R: '', Y: '', B: '' },
                '100%': { R: '', Y: '', B: '' }
              },
              measuredCurrent: {
                '25%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
                '50%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
                '75%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' },
                '100%': { R: '', Y: '', B: '', RError: '', YError: '', BError: '' }
              }
            };
          }
        }
        return updated;
      });
    }
  }, [selectedCore]);

  useEffect(() => {
    const ctFormData = localStorage.getItem('ctFormData');
    if (ctFormData) {
      try {
        const parsedData = JSON.parse(ctFormData);
   

        if (parsedData.coreDetails) {
          const totalCores = parseInt(parsedData.selectedCore || selectedCores || '1');
          let hasVkYes = false;

          for (let i = 0; i < totalCores; i++) {
            
            if (parsedData.coreDetails[i]?.vk === "Yes") {
              hasVkYes = true;
              break;
            }
          }

        
          setShouldShowKneePoint(hasVkYes);
        }
      } catch (error) {
       
        setShouldShowKneePoint(false);
      }
    } else {
      
      setShouldShowKneePoint(false);
    }
  }, [selectedCores]);

  useEffect(() => {
    try {
      const localNavbarData = localStorage.getItem('navbarData');
      const localProjectData = localStorage.getItem('createReportData');

      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }

      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }
    } catch (error) {
     
      setErrorMessage("Failed to load saved data");
    }
  }, []);

  const calculateAppliedCurrent = (primary, percentage) => {
    const primaryNum = parseFloat(primary) || 0;
    const percentageValue = parseFloat(percentage.replace('%', '')) / 100;
    return (primaryNum * percentageValue).toFixed(2);
  };

  const calculateExpectedSecondary = (primary, secondary, appliedValue) => {
    const primaryNum = parseFloat(primary) || 1;
    const secondaryNum = parseFloat(secondary) || 1;
    const applied = parseFloat(appliedValue) || 0;

    return ((secondaryNum / primaryNum) * applied).toFixed(4);
  };

  const calculatePercentageError = (measuredValue, appliedValue, primary, secondary) => {
    const measured = parseFloat(measuredValue);
    const expectedSecondary = calculateExpectedSecondary(primary, secondary, appliedValue);
    const expected = parseFloat(expectedSecondary);

    if (isNaN(measured) || isNaN(expected) || expected === 0) {
      return '';
    }

    const error = ((measured - expected) / expected) * 100;
    return Math.abs(error).toFixed(2);
  };

  const handleCoreChange = (e) => {
    const value = e.target.value;
    setSelectedCores(value);
  };

  const handleCoreRatioChange = (coreNumber, newRatioValue) => {
    setCoreRatios(prev => {
      const updated = { ...prev };

      if (newRatioValue.includes('/')) {
        const parts = newRatioValue.split('/');
        const primary = parts[0].trim();
        let secondary = parts[1].trim();

        if (secondary.endsWith('A')) {
          secondary = secondary.slice(0, -1);
        }

        updated[coreNumber] = {
          ratioValue: newRatioValue,
          primaryValue: primary,
          secondaryValue: secondary
        };
      } else {
        updated[coreNumber] = {
          ...updated[coreNumber],
          ratioValue: newRatioValue,
          primaryValue: newRatioValue
        };
      }

      return updated;
    });

    updateAppliedCurrentsForCore(coreNumber, newRatioValue);
  };

  const updateAppliedCurrentsForCore = (coreNumber, ratioValue) => {
    let primary = '';
    let secondary = '';

    if (ratioValue.includes('/')) {
      const parts = ratioValue.split('/');
      primary = parts[0].trim();
      secondary = parts[1].trim();

      if (secondary.endsWith('A')) {
        secondary = secondary.slice(0, -1);
      }
    } else {
      primary = ratioValue;
      secondary = coreRatios[coreNumber]?.secondaryValue || '1';
    }

    setForm(prevForm => {

      const updatedForm = {
        ...prevForm,
        [`ratioTest${coreNumber}`]: {
          ...prevForm[`ratioTest${coreNumber}`],
          appliedCurrent: {
            ...prevForm[`ratioTest${coreNumber}`].appliedCurrent
          },
          measuredCurrent: {
            ...prevForm[`ratioTest${coreNumber}`].measuredCurrent
          }
        }
      };


      ['25%', '50%', '75%', '100%'].forEach(percentage => {
        updatedForm[`ratioTest${coreNumber}`].appliedCurrent[percentage] = {
          ...prevForm[`ratioTest${coreNumber}`].appliedCurrent[percentage]
        };
        updatedForm[`ratioTest${coreNumber}`].measuredCurrent[percentage] = {
          ...prevForm[`ratioTest${coreNumber}`].measuredCurrent[percentage]
        };

        ['R', 'Y', 'B'].forEach(phase => {
          const calculatedValue = calculateAppliedCurrent(primary, percentage);
          updatedForm[`ratioTest${coreNumber}`].appliedCurrent[percentage][phase] = calculatedValue;

          const measuredValue = updatedForm[`ratioTest${coreNumber}`].measuredCurrent[percentage][phase];
          if (measuredValue) {
            updatedForm[`ratioTest${coreNumber}`].measuredCurrent[percentage][`${phase}Error`] =
              calculatePercentageError(measuredValue, calculatedValue, primary, secondary);
          }
        });
      });

      return updatedForm;
    });
  };

  const handleRatioChange = (testNum, type, percentage, field, value) => {
    const coreRatio = coreRatios[testNum];
    if (!coreRatio) return;

    setForm(prevForm => {

      const updatedForm = {
        ...prevForm,
        [`ratioTest${testNum}`]: {
          ...prevForm[`ratioTest${testNum}`],
          appliedCurrent: {
            ...prevForm[`ratioTest${testNum}`].appliedCurrent,
            [percentage]: {
              ...prevForm[`ratioTest${testNum}`].appliedCurrent[percentage]
            }
          },
          measuredCurrent: {
            ...prevForm[`ratioTest${testNum}`].measuredCurrent,
            [percentage]: {
              ...prevForm[`ratioTest${testNum}`].measuredCurrent[percentage]
            }
          }
        }
      };

      if (type === 'applied') {
        updatedForm[`ratioTest${testNum}`].appliedCurrent[percentage][field] = value;

        const measuredValue = updatedForm[`ratioTest${testNum}`].measuredCurrent[percentage][field];

        if (measuredValue) {
          updatedForm[`ratioTest${testNum}`].measuredCurrent[percentage][`${field}Error`] =
            calculatePercentageError(measuredValue, value, coreRatio.primaryValue, coreRatio.secondaryValue);
        }
      } else if (type === 'measured') {
        updatedForm[`ratioTest${testNum}`].measuredCurrent[percentage][field] = value;

        const appliedValue = updatedForm[`ratioTest${testNum}`].appliedCurrent[percentage][field];
        if (value) {
          updatedForm[`ratioTest${testNum}`].measuredCurrent[percentage][`${field}Error`] =
            calculatePercentageError(value, appliedValue, coreRatio.primaryValue, coreRatio.secondaryValue);
        } else {
          updatedForm[`ratioTest${testNum}`].measuredCurrent[percentage][`${field}Error`] = '';
        }
      }

      return updatedForm;
    });
  };

  const handleChecklistChange = (key, value) => {
    setChecklistData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const goBack = () => {
    try {
      localStorage.setItem('assistanceData', JSON.stringify(form));
      localStorage.setItem('transformerRatioTestData', JSON.stringify(form));
    } catch (error) {
    
    }

    if (goBackToPolarity) {
      goBackToPolarity(form);
    }
  };

  const handleNext = () => {
   

    if (currentPage === 'ratioTest') {
      if (shouldShowKneePoint) {
       
        setCurrentPage('points');
      } else {
        
        handleSubmit();
      }
    } else {
    
      handleSubmit();
    }
  };




  const generateWordBlob = () => {
    return new Promise((resolve, reject) => {
      try {

        const testCTFormData = JSON.parse(localStorage.getItem('ctFormData') || '{}');
        const testCTGeneralData = JSON.parse(localStorage.getItem('ctGeneralData') || '{}');
        const transformerCTWindingData = JSON.parse(localStorage.getItem('transformerWindingPolarityData') || '{}');
        const testCTRatioData = JSON.parse(localStorage.getItem('transformerRatioTestData') || '{}');

        const tableBorders = {
          top: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
          bottom: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
          left: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
          right: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" }
        };

        const pageBorders = {
          top: { style: BorderStyle.SINGLE, size: 12, color: "000000", space: 24 },
          bottom: { style: BorderStyle.SINGLE, size: 12, color: "000000", space: 24 },
          left: { style: BorderStyle.SINGLE, size: 12, color: "000000", space: 24 },
          right: { style: BorderStyle.SINGLE, size: 12, color: "000000", space: 24 }
        };



        const formatFieldLabel = (key) => {
          const specialCases = {
            'yom': 'Year of Manufacture',
            'il': 'Insulation Level',
            'stc': 'Short Time Current',
            'selectedFrequency': 'Frequency',
            'selectedCore': 'Number of Cores',
            'selectedSecTerm': 'Secondary Terminal',
            'reportNo': 'Report No',
            // 'vkValue': 'VK Value',
            'rct': 'RCT',
            'imageAtVkHalf': 'Image@VK/2'
          };

          if (specialCases[key]) {
            return specialCases[key];
          }

          return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim();
        };


        const getRemainingFormFields = (formData) => {
          const fields = [];
          const excludeFields = ['description', 'project', 'customer', 'client', 'date', 'reportNo', 'coreDetails', 'location'];

          const fieldOrder = [
            'yom', 'make', 'serialNumber', 'il', 'stc', 'insulationClass',
            'numberOfCores', 'secondaryTerminal', 'selectedFrequency', 'selectedCore',
            'selectedSecTerm'
          ];



          fieldOrder.forEach(key => {
            if (formData.hasOwnProperty(key) &&
              formData[key] !== null &&
              formData[key] !== undefined &&
              !excludeFields.includes(key)) {
              fields.push({
                label: formatFieldLabel(key),
                value: String(formData[key])
              });
            }
          });

          Object.keys(formData).forEach(key => {
            if (!fieldOrder.includes(key) &&
              !excludeFields.includes(key) &&
              formData[key] !== null &&
              formData[key] !== undefined) {
              fields.push({
                label: formatFieldLabel(key),
                value: String(formData[key])
              });
            }
          });

          return fields;
        };

        function safeToString(value) {
          if (value === null || value === undefined || value === '' || value === '-') {
            return "";
          }
          return value.toString();
        }


        const getUnitSymbol = (unitType) => {
          const unitSymbols = {
            'OHMS': 'Ω',
            'MILLIOHMS': 'mΩ',
            'NANOOHMS': 'nΩ'
          };
          return unitSymbols[unitType] || '';
        };

        const numCores = parseInt(testCTFormData.selectedCore || testCTFormData.numberOfCores || 0);
        const remainingFields = getRemainingFormFields(testCTFormData);


        const fetchImageAsBase64 = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                const base64 = dataURL.split(',')[1];
                resolve(base64);
              } catch (error) {
                
                resolve(null);
              }
            };
            img.onerror = function () {
             
              resolve(null);
            };
            img.src = url;
          });
        };


        const documentSections = [];


        const createLightWatermark = (base64Data) => {
          return new Promise((resolve) => {
            if (!base64Data) {
              resolve(null);
              return;
            }

            try {
              const img = new Image();
              img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;


                ctx.globalAlpha = 0.15;
                ctx.drawImage(img, 0, 0);

                const lightDataURL = canvas.toDataURL('image/png');
                const lightBase64 = lightDataURL.split(',')[1];
                resolve(lightBase64);
              };
              img.onerror = function () {
                resolve(null);
              };
              img.src = 'data:image/png;base64,' + base64Data;
            } catch (error) {
             
              resolve(null);
            }
          });
        };

        const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";

        const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";


        Promise.all([
          fetchImageAsBase64(logoUrl),
          fetchImageAsBase64(watermarkUrl)
        ]).then(([logoBase64, watermarkBase64]) => {


          createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {

            const headerElements = [];

            if (logoBase64) {
              headerElements.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: logoBase64,
                                  transformation: {
                                    width: 80,
                                    height: 80
                                  }
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                            })
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 20, type: WidthType.PERCENTAGE },
                          margins: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "PIE POWER PRIVATE LIMITED",
                                  font: "Times New Roman",
                                  color: "#1e402c",
                                  bold: true,
                                  size: 36
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 80, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ]
                })
              );
            }

            else {

              headerElements.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "PIE POWER PRIVATE LIMITED",
                      font: "Times new roman",
                      color: "#1e402c",
                      bold: true,
                      size: 36
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                      font: "Courier New",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                      font: "Courier New",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                })
              );
            }

            headerElements.push(new Paragraph({ text: "" }));
            documentSections.push(...headerElements);



            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CURRENT TRANSFORMER INSPECTION / TEST REPORT", font: "Courier New", bold: true, })] })],
                        borders: tableBorders,
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Date", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: testCTFormData.date || "", font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      })

                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Project", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: testCTFormData.project || "", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Report No", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: testCTFormData.reportNo || "", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Customer", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: testCTFormData.customer || "", font: "Courier New", bold: true, })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Client", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: testCTFormData.client || "", font: "Courier New", bold: true, })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));






            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "LOCATION: ",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  }),
                  new TextRun({
                    text: safeToString(testCTFormData?.location),
                    font: "Courier New",
                    size: 24
                  })
                ]
              })
            );
            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "NAME PLATE DETAILS",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );


            if (remainingFields.length > 0) {
              const fieldRows = [];

              remainingFields.forEach(field => {
                fieldRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.label, font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.value, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 50, type: WidthType.PERCENTAGE },
                      }),
                    ]
                  })
                );
              });

              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: fieldRows
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Core Details",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            const coreRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Core", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Ratio", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Class", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                
                ]
              })
            ];

            if (testCTFormData?.coreDetails && testCTFormData.coreDetails.length > 0) {
              for (let i = 0; i < numCores; i++) {
                const core = testCTFormData.coreDetails[i] || {};
                coreRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `Core ${i + 1}`, font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: core.ratio || "", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: core.class || "", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                     
                    ]
                  })
                );

                if (core.vk === "Yes") {
                  coreRows.push(
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "Image@VK/2:" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: core.imageAtVkHalf || "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        })
                      ]
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "  RCT:" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: core.rct || "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                          borders: tableBorders
                        })
                      ]
                    })
                  );
                }
              }
            } else {
              coreRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ children: [new TextRun({ text: "No core details available" })] })],
                      borders: tableBorders,
                      columnSpan: 5
                    })
                  ]
                })
              );
            }

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: coreRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));

            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "General Inspection",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );


            const inspectionRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Inspection Type", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  })
                ]



              })
            ];


            if (testCTGeneralData?.generalInspection) {
              const inspectionData = [
                ["Visual Inspection", testCTGeneralData.generalInspection.visualInspection || ""],
                ["Wiring Checking", testCTGeneralData.generalInspection.wiringChecking || ""],
                ["Erection Checking", testCTGeneralData.generalInspection.erectionChecking || ""]
              ];

              inspectionData.forEach(([type, status]) => {
                inspectionRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: type, bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: status, font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                );
              });
            } else {
              inspectionRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ children: [new TextRun({ text: "No general inspection data available" })] })],
                      borders: tableBorders,
                      columnSpan: 2
                    })
                  ]
                })
              );
            }

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: inspectionRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Insulation Resistance Measurement",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            function formatInsulationValue(value, unit) {
              if (!value && value !== 0) return "";
              const unitText = unit || 'MΩ';
              return `${safeToString(value)} ${unitText}`;
            }

            const insulationRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            if (testCTGeneralData?.formData && testCTGeneralData?.rows && testCTGeneralData.rows.length > 0) {
              const references = Object.keys(testCTGeneralData.formData);

              testCTGeneralData.rows.forEach((row, index) => {
                const reference = references[index];
                if (reference) {

                  const rowUnits = testCTGeneralData.units && testCTGeneralData.units[index]
                    ? testCTGeneralData.units[index]
                    : { r: 'MΩ', y: 'MΩ', b: 'MΩ' };


                  let rValue, yValue, bValue;


                  if (typeof row.r === 'object' && row.r !== null) {
                    rValue = row.r.value || row.r;
                  } else {
                    rValue = row.r;
                  }

                  if (typeof row.y === 'object' && row.y !== null) {
                    yValue = row.y.value || row.y;
                  } else {
                    yValue = row.y;
                  }

                  if (typeof row.b === 'object' && row.b !== null) {
                    bValue = row.b.value || row.b;
                  } else {
                    bValue = row.b;
                  }


                  const rUnit = rowUnits.r || 'MΩ';
                  const yUnit = rowUnits.y || 'MΩ';
                  const bUnit = rowUnits.b || 'MΩ';

                  insulationRows.push(
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: reference, font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(testCTGeneralData.formData[reference]), font: "Courier New" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatInsulationValue(rValue, rUnit), font: "Courier New" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatInsulationValue(yValue, yUnit), font: "Courier New" })] })],
                          borders: tableBorders
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatInsulationValue(bValue, bUnit), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    })
                  );
                }
              });
            } else {
              insulationRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ children: [new TextRun({ text: "No insulation resistance data available", font: "Courier New" })] })],
                      borders: tableBorders,
                      columnSpan: 5
                    })
                  ]
                })
              );
            }

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: insulationRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));



            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Winding Resistance",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            const windingRows = [
              new TableRow({
                children: [
                  new TableCell({
                    alignment: AlignmentType.CENTER,
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            let hasWindingData = false;

            if (transformerCTWindingData && transformerCTWindingData.windingResistance) {
              for (let i = 1; i <= numCores; i++) {
                const ref = `${i}S1-${i}S2`;
                if (transformerCTWindingData.windingResistance[ref]) {
                  const rData = transformerCTWindingData.windingResistance[ref].R || {};
                  const yData = transformerCTWindingData.windingResistance[ref].Y || {};
                  const bData = transformerCTWindingData.windingResistance[ref].B || {};

                  if (rData.value || yData.value || bData.value) {
                    hasWindingData = true;
                    windingRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ref, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: rData.value ? `${rData.value} ${rData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: yData.value ? `${yData.value} ${yData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: bData.value ? `${bData.value} ${bData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  }
                }
              }
            }

            if (!hasWindingData) {
              windingRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ children: [new TextRun({ text: "No winding resistance data available" })] })],
                      borders: tableBorders,
                      columnSpan: 4
                    })
                  ]
                })
              );
            }

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: windingRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Polarity Check",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            const polarityRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            let hasPolarityData = false;

            if (transformerCTWindingData && transformerCTWindingData.polarityCheck) {
              for (let i = 1; i <= numCores; i++) {
                const ref = `${i}S1-${i}S2`;
                if (transformerCTWindingData.polarityCheck[ref]) {
                  const rData = transformerCTWindingData.polarityCheck[ref].R || {};
                  const yData = transformerCTWindingData.polarityCheck[ref].Y || {};
                  const bData = transformerCTWindingData.polarityCheck[ref].B || {};

                  if (rData.value || yData.value || bData.value) {
                    hasPolarityData = true;
                    polarityRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ref, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: rData.value || "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: yData.value || "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: bData.value || "", font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  }
                }
              }
            }

            if (!hasPolarityData) {
              polarityRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ children: [new TextRun({ text: "No polarity check data available" })] })],
                      borders: tableBorders,
                      columnSpan: 4
                    })
                  ]
                })
              );
            }

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: polarityRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Ratio Test",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            let hasRatioData = false;

            for (let i = 1; i <= numCores; i++) {
              const coreRatioData = testCTRatioData[`ratioTest${i}`] ||
                testCTRatioData[`core${i}`] ||
                (i === 1 ? testCTRatioData.ratioTest : null) ||
                testCTRatioData[`ratioTest`];

              if (coreRatioData && (coreRatioData.appliedCurrent || coreRatioData.measuredCurrent)) {
                hasRatioData = true;


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `Core ${i} (${i}S1-${i}S2)`,
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Applied Current (Primary)(A)",
                        font: "Courier New",
                        bold: true,
                        size: 20
                      })
                    ]
                  })
                );


                const appliedCurrentRows = [];


                appliedCurrentRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Percentage", font: "Courier New", bold: true, size: 20 })]
                        })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      })
                    ]
                  })
                );


                ["25%", "50%", "75%", "100%"].forEach(percentage => {
                  if (coreRatioData.appliedCurrent && coreRatioData.appliedCurrent[percentage]) {
                    const appliedCurrentData = coreRatioData.appliedCurrent[percentage];
                    appliedCurrentRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: percentage, font: "Courier New", bold: true, size: 20 })]
                            })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(appliedCurrentData.R || ""), font: "Courier New", size: 20 })]
                            })],

                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(appliedCurrentData.Y || ""), font: "Courier New", size: 20 })]
                            })],

                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(appliedCurrentData.B || ""), font: "Courier New", size: 20 })]
                            })],

                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  }
                });

                documentSections.push(
                  new Table({
                    rows: appliedCurrentRows,
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE
                    }
                  })
                );


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Measured Current (Secondary)(A)",
                        font: "Courier New",
                        bold: true,
                        size: 20
                      })
                    ]
                  })
                );


                const measuredCurrentRows = [];


                measuredCurrentRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Percentage", font: "Courier New", bold: true, size: 20 })]
                        })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Error ", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Error ", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: "Error ", font: "Courier New", bold: true, size: 20 })]
                        })],
                        shading: {
                          fill: "a6a6a6"
                        },
                        borders: tableBorders
                      })
                    ]
                  })
                );


                ["25%", "50%", "75%", "100%"].forEach(percentage => {
                  if (coreRatioData.measuredCurrent && coreRatioData.measuredCurrent[percentage]) {
                    const measuredCurrentData = coreRatioData.measuredCurrent[percentage];
                    measuredCurrentRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: percentage, font: "Courier New", bold: true, size: 20 })]
                            })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(measuredCurrentData.R || ""), font: "Courier New", size: 20 })]
                            })],

                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: measuredCurrentData.RError ? `${measuredCurrentData.RError}` : "", font: "Courier New", size: 20 })]
                            })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(measuredCurrentData.Y || ""), font: "Courier New", size: 20 })]
                            })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: measuredCurrentData.YError ? `${measuredCurrentData.YError}` : "", font: "Courier New", size: 20 })]
                            })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: String(measuredCurrentData.B || ""), font: "Courier New", size: 20 })]
                            })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({ text: measuredCurrentData.BError ? `${measuredCurrentData.BError}` : "", font: "Courier New", size: 20 })]
                            })],
                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  }
                });

                documentSections.push(
                  new Table({
                    rows: measuredCurrentRows,
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE
                    }
                  })
                );


                documentSections.push(new Paragraph({ text: "" }));
              }
            }

            if (!hasRatioData) {
              const noRatioRows = [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({
                        children: [new TextRun({ text: "Status", font: "Courier New", bold: true, size: 20 })]
                      })],
                      borders: tableBorders
                    })
                  ]
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({
                        children: [new TextRun({ text: "No ratio test data available", font: "Courier New", size: 20 })]
                      })],
                      borders: tableBorders
                    })
                  ]
                })
              ];

              documentSections.push(
                new Table({
                  rows: noRatioRows,
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE
                  }
                })
              );
            }




            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "CT Check List",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            const checklistRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "S.No.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 10, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Check Point", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 70, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remarks", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            const checklistItems = [
              { key: 'ASS-00', text: 'All CT quantity, rating, type & make are as per approved drawings.' },
              { key: 'ASS-01', text: 'No physical damage to any of the CT.' },
              { key: 'ASS-02', text: 'Inter-panel wiring from CTs to disconnector Terminal blocks in panel is as per approved drawing.' },
              { key: 'ASS-03', text: 'CT secondary star point terminals are properly earthed at disconnector terminal blocks.' },
              { key: 'ASS-04', text: 'CT wiring ferrules are as per drawing.' },
              { key: 'ASS-05', text: 'All CT connections are properly tightened.' }
            ];

            const storedChecklistData = JSON.parse(localStorage.getItem('ctChecklistData') || '{}');
            const currentChecklistData = storedChecklistData;
            checklistItems.forEach((item, index) => {
              checklistRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: String(index + 1), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: item.text, font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: currentChecklistData[item.key] || "OK", font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: checklistRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));



            documentSections.push(new Paragraph({ text: "" }));


            const convertInchesToTwip = (inches) => {
              return Math.round(inches * 1440);
            };

            const footerTable = new Table({
              width: { size: 100, type: WidthType.PERCENTAGE, },
              alignment: AlignmentType.LEFT,
              rows: [
                new TableRow({
                  height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "Pie Power",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            }),
                            new SimpleField({
                              instruction: "PAGE",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            }),
                            new SimpleField({
                              instruction: "NUMPAGES",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    })
                  ]
                })
              ]
            });

            const pageBorders = {
              pageBorderTop: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },


              pageBorderRight: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderBottom: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderLeft: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              }
            };

            const doc = new Document({
              sections: [
                {
                  properties: {
                    page: {
                      margin: {
                        top: convertInchesToTwip(0.5),
                        right: convertInchesToTwip(0.5),
                        bottom: convertInchesToTwip(1.0),
                        left: convertInchesToTwip(0.5)
                      },
                      borders: pageBorders,
                      pageNumbers: {
                        start: 1,
                        formatType: NumberFormat.DECIMAL
                      }
                    }
                  },
                  footers: {
                    default: new Footer({
                      children: [
                        footerTable,
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Page ",
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              children: [PageNumber.CURRENT],
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              text: " of ",
                              font: "Courier New",
                              size: 16
                            }),

                            new TextRun({
                              children: [PageNumber.TOTAL_PAGES],
                              font: "Courier New",
                              size: 16
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                          spacing: {
                            before: 200
                          }
                        })
                      ]
                    })
                  },
                  headers: lightWatermarkBase64 ? {
                    default: new Header({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: lightWatermarkBase64,
                              transformation: {
                                width: 500,
                                height: 500
                              },
                              floating: {
                                horizontalPosition: {
                                  relative: HorizontalPositionRelativeFrom.PAGE,
                                  align: HorizontalPositionAlign.CENTER
                                },
                                verticalPosition: {
                                  relative: VerticalPositionRelativeFrom.PAGE,
                                  align: VerticalPositionAlign.CENTER
                                },
                                wrap: {
                                  type: TextWrappingType.BEHIND_TEXT
                                },
                                allowOverlap: true,
                                behindDocument: true
                              }
                            })
                          ]
                        })
                      ]
                    })
                  } : undefined,
                  children: documentSections
                }
              ]
            });



            Packer.toBlob(doc).then(blob => {
              resolve(blob);
            }).catch(error => {
           
              reject(error);
            });
          });

        }).catch(error => {
        

          const doc = new Document({
            sections: [
              {
                properties: {
                  page: {
                    margin: {
                      top: convertInchesToTwip(0.25),
                      right: convertInchesToTwip(0.25),
                      bottom: convertInchesToTwip(1.0),
                      left: convertInchesToTwip(0.25)
                    }
                  }
                },
                footers: {
                  default: new Footer({

                  })
                },
                children: documentSections
              }
            ]
          });


          Packer.toBlob(doc).then(blob => {
            resolve(blob);
          }).catch(error => {
          
            reject(error);
          });
        });

      } catch (error) {
   
        reject(error);
      }
    });
  };






  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setFormSubmitted(true);
    setIsLoading(true);
    setErrorMessage("");

    try {

      localStorage.setItem('transformerRatioTestData', JSON.stringify(form));
      localStorage.setItem('assistanceData', JSON.stringify(form));
    
   
      localStorage.setItem('transformerRatioTestDataUpdate', JSON.stringify(form));

      const loadFormDataSafely = (key, defaultValue = {}) => {
        try {
          const data = localStorage.getItem(key);
          return data ? JSON.parse(data) : defaultValue;
        } catch (error) {
        
          return defaultValue;
        }
      };

      const ensureDictFormat = (data, keyPrefix = 'item') => {
        if (Array.isArray(data)) {
          const dict = {};
          data.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              Object.keys(item).forEach(key => {
                dict[`${keyPrefix}_${index}_${key}`] = item[key];
              });
            } else {
              dict[`${keyPrefix}_${index}`] = item;
            }
          });
          return dict;
        } else if (typeof data === 'object' && data !== null) {
          return data;
        } else {
          return { value: data };
        }
      };

      const loadAllFormDataFromStorage = () => {
        try {
          const ctFormData = loadFormDataSafely('ctFormData', {});
          const ctGeneralData = loadFormDataSafely('ctGeneralData', {});
          const transformerWindingData = loadFormDataSafely('transformerWindingPolarityData', {});
          const transformerRatioData = loadFormDataSafely('transformerRatioTestData', {});
          const ctReportData = loadFormDataSafely('ct_report_data', {});
          const navbarData = loadFormDataSafely('navbarData', {});
          const createReportData = loadFormDataSafely('createReportData', {});

          const mergedGeneralData = {
            ...ctReportData,
            ...ctGeneralData,
            ...ctFormData,
            ...generalData
          };

          const mergedRatioData = {
            ...transformerRatioData,
            ...ratioData,
            ...form
          };

          const mergedPolarityData = {
            ...transformerWindingData,
            ...windingPolarityData
          };

          return {
            general: mergedGeneralData,
            assistanceData: loadFormDataSafely('assistanceData', assistanceData || {}),
            ratioData: mergedRatioData,
            windingPolarityData: mergedPolarityData,
            coreRatios: loadFormDataSafely('transformerCoreRatios', coreRatios || {}),
            observations: loadFormDataSafely('observations', {}),
            recommendations: loadFormDataSafely('recommendations', {}),
            pointsData: loadFormDataSafely('pointsData', {}),
            kneePointData: loadFormDataSafely('kneePointData', {}),
            navbarData: navbarData,
            createReportData: createReportData,
            checklistData: checklistData
          };
        } catch (error) {
      ;
          return {
            general: ensureDictFormat(generalData || {}, 'general'),
            assistanceData: ensureDictFormat(assistanceData || {}, 'assistance'),
            ratioData: ensureDictFormat({ ...ratioData, ...form } || {}, 'ratio'),
            windingPolarityData: ensureDictFormat(windingPolarityData || {}, 'polarity'),
            coreRatios: ensureDictFormat(coreRatios || {}, 'core'),
            observations: ensureDictFormat({}, 'observation'),
            recommendations: ensureDictFormat({}, 'recommendation'),
            pointsData: ensureDictFormat({}, 'points'),
            kneePointData: ensureDictFormat({}, 'knee'),
            navbarData: ensureDictFormat({}, 'navbar'),
            createReportData: ensureDictFormat({}, 'create_report'),
            checklistData: checklistData
          };
        }
      };

      const allFormData = loadAllFormDataFromStorage();

      const safeFormData = {
        general: allFormData.general,
        assistanceData: allFormData.assistanceData,
        ratioData: allFormData.ratioData,
        windingPolarityData: allFormData.windingPolarityData,
        coreRatios: allFormData.coreRatios,
        observations: allFormData.observations,
        recommendations: allFormData.recommendations,
        pointsData: allFormData.pointsData,
        kneePointData: allFormData.kneePointData,
        navbarData: allFormData.navbarData,
        createReportData: allFormData.createReportData,
        checklistData: allFormData.checklistData
      };

    

      const wordBlob = await generateWordBlob(safeFormData);

      const reader = new FileReader();
      reader.readAsDataURL(wordBlob);

      reader.onloadend = async () => {
        try {
          const base64data = reader.result;

          localStorage.setItem('assistanceTestReportWord', base64data);
          const currentDate = new Date().toISOString().split('T')[0];

          const extractLocation = () => {
            const locationSources = [
              safeFormData?.general?.location,
              safeFormData?.general?.testLocation,
              safeFormData?.general?.site,
              safeFormData?.general?.place,
              safeFormData?.navbarData?.location,
              safeFormData?.createReportData?.location,
              projectDetails?.location,
              generalData?.location
            ];

            for (let loc of locationSources) {
              if (loc) {
                if (typeof loc === 'object' && loc !== null) {
                  loc = loc.value || loc.name || loc.location || loc.text || String(loc);
                }

                const finalLoc = String(loc).trim();
                if (finalLoc && finalLoc !== "" && finalLoc !== "undefined" && finalLoc !== "null") {
                
                  return finalLoc;
                }
              }
            }

            return "Default Location";
          };

          const testLocation = extractLocation();


          const getProjectId = () => {
          

            if (projectDetails?.projectId) {
              const id = parseInt(projectDetails.projectId);
              if (!isNaN(id) && id > 0) {
               
                return id;
              }
            }
           

            if (safeFormData?.createReportData?.project_id) {
              const id = parseInt(safeFormData.createReportData.project_id);
              if (!isNaN(id) && id > 0) {
               
                return id;
              }
            }
        

            if (safeFormData?.general?.project_id) {
              const id = parseInt(safeFormData.general.project_id);
              if (!isNaN(id) && id > 0) {
         
                return id;
              }
            }
            if (safeFormData?.general?.reportNo) {
              const id = parseInt(String(safeFormData.general.reportNo).replace(/\D/g, ''));
              if (!isNaN(id) && id > 0) {
       
                return id;
              }
            }
           

            alert("Warning: Could not determine project ID. Report may be saved incorrectly.");
            return 1;
          };

          const projectId = getProjectId();
          


          const getSubProjectName = () => {
           


            const sources = [
              safeFormData?.createReportData?.sub_project_name,
              safeFormData?.createReportData?.subProjectName,
              projectDetails?.subProjectName,
              safeFormData?.general?.sub_project_name,
              safeFormData?.general?.subproject_name,
              safeFormData?.general?.subProjectName,
              allFormData?.createReportData?.sub_project_name,
              allFormData?.navbarData?.sub_project_name
            ];

            for (let source of sources) {
              if (source && typeof source === 'string' && source.trim()) {
         
                return source.trim();
              }
            }


            const projectFallback = safeFormData?.general?.project;
            if (projectFallback && typeof projectFallback === 'string' && projectFallback.trim()) {
              
              return projectFallback.trim();
            }

          
            return "CT Assistance Project";
          };

          const subProjectName = getSubProjectName();


          const apiRequestData = {
  equipment_name: String(
    safeFormData?.general?.equipment_name ||
    safeFormData?.general?.equipmentName ||
    projectDetails?.equipmentName ||
    safeFormData?.general?.equipment ||
    "CT Assistance Equipment"
  ),
  test_date: String(
    safeFormData?.general?.test_date ||
    safeFormData?.general?.date ||
    currentDate
  ),
  category_name: String(
    safeFormData?.general?.category_name ||
    projectDetails?.categoryName ||
    "Current Transformer"
  ),
  subcategory_name: String(
    safeFormData?.general?.subcategory_name ||
    projectDetails?.subcategoryName ||
    "Assistance Test"
  ),
  sub_project_name: subProjectName,
  project_id: projectId,
  location: String(testLocation || ""),
  report_file: {
    report_word: base64data,
    filename: `CT_Assistance_Test_Report_${Date.now()}.docx`,
    file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  test_data: {
    
    assistanceData: form,  
    ratioData: form,       
    general: safeFormData.general,
    windingPolarityData: safeFormData.windingPolarityData,
    coreRatios: safeFormData.coreRatios,
    observations: safeFormData.observations,
    recommendations: safeFormData.recommendations,
    pointsData: safeFormData.pointsData,
    kneePointData: safeFormData.kneePointData,
    checklistData: checklistData
  }
};


        

          const response = await fetch(`${API_URL}/test_report/create_test_report`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(apiRequestData),
            mode: 'cors',
            credentials: 'same-origin',
          });

          if (!response.ok) {
            let errorData;
            try {
              errorData = await response.json();
             
            } catch (jsonError) {
              
              errorData = { message: response.statusText };
            }

            throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
          }

          const result = await response.json();
        

          setIsFormSubmitted(true);
          localStorage.setItem('assistanceFormSubmitted', 'true');

          localStorage.setItem('assistanceData', JSON.stringify(safeFormData));
          localStorage.setItem('ratioData', JSON.stringify(safeFormData.ratioData));

          if (onSave) {
            onSave(safeFormData);
          }

          alert("Data and Word document submitted successfully");

        } catch (error) {
         
          setErrorMessage(`Error: ${error.message}`);
          alert(`Error saving data: ${error.message}`);
        } finally {
          setIsLoading(false);
        }
      };

    } catch (error) {
     

      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running.");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else if (error.message.includes("generateWordBlob is not defined")) {
        setErrorMessage("Word document generation function is missing. Please check your imports.");
        alert("Word document generation function is missing. Please check your imports.");
      } else {
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      }
      setIsLoading(false);
    }
  };

  const handleBackFromPoints = () => {
    setCurrentPage('ratioTest');
  };

  const handleBackFromKneePoint = (kneePointData) => {
    setCurrentPage('points');
  };

  const handleCompleteSubmit = (kneePointData) => {
    try {
      setIsLoading(true);
      setErrorMessage('');

      localStorage.setItem('assistanceData', JSON.stringify(form));
      localStorage.setItem('ratioData', JSON.stringify(form));
      localStorage.setItem('assistanceFormSubmitted', 'true');

      alert("Data submitted successfully!");

      setFormSubmitted(true);

      if (goBackToPolarity) {
        goBackToPolarity(form);
      }

    } catch (error) {
      
      setErrorMessage(error.message || "Failed to save combined data");
      alert(`Error: ${error.message || "Failed to save combined data"}`);
    } finally {
      setIsLoading(false);
    }
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const allFormData = loadAllFormDataFromStorage();
      const safeFormData = allFormData && typeof allFormData === 'object' ? allFormData : {
        circuitBreakerData,
        testData,
        contactData,
        operationalChecksData: form,
        projectDetails
      };

      const wordBlob = await generateWordBlob();

      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      const filename = `CurrentTransformer_Report_${circuitBreakerData.reportNo || formattedDate}.docx`;

      saveAs(wordBlob, filename);

      clearAllStorageData();
      resetAllFormStates();
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(CLEAR_DATA_EVENT_NAME));
      }

      alert("Word document downloaded successfully");


    } catch (error) {
     
      setErrorMessage(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  if (currentPage === 'points') {
    return (
      <Points
        selectedCore={selectedCores}
        ratioData={form}
        goBack={handleBackFromPoints}
        handleNext={() => setCurrentPage('kneePointTest')}
      />
    );
  }

  if (currentPage === 'kneePointTest') {
    return (
      <Ratio
        goBack={handleBackFromPoints}
        formData={JSON.parse(localStorage.getItem('ctFormData') || '{}')}
        generalData={JSON.parse(localStorage.getItem('ct_report_data') || '{}')}
        ratioData={form}
        assistanceData={form}
        onSave={handleCompleteSubmit}
      />
    );
  }

  const renderAppliedCurrentRows = (testNum) => {
    const coreRatio = coreRatios[testNum] || { primaryValue: '250', secondaryValue: '1' };

    return ['25%', '50%', '75%', '100%'].map((percentage) => {
      const calculatedValue = calculateAppliedCurrent(coreRatio.primaryValue, percentage);

      return (
        <div key={`applied-${testNum}-${percentage}`} className="percentage-row">
          <div className="percentage-label">{percentage}</div>
          <div className="phase-inputs">
            {['R', 'Y', 'B'].map((phase) => {
              if (form[`ratioTest${testNum}`].appliedCurrent[percentage][phase] === '') {
                setTimeout(() => {
                  handleRatioChange(testNum, 'applied', percentage, phase, calculatedValue);
                }, 0);
              }

              return (
                <div key={`applied-${phase}`} className="phase-column">
                  <div className="phase-input">
                    <div className="input-wrapper">
                      <input
                        className="input-field small"
                        value={form[`ratioTest${testNum}`].appliedCurrent[percentage][phase] || calculatedValue}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  const renderMeasuredCurrentRows = (testNum) => {
    const coreRatio = coreRatios[testNum] || { primaryValue: '250', secondaryValue: '1' };

    return ['25%', '50%', '75%', '100%'].map((percentage) => (
      <div key={`measured-${testNum}-${percentage}`} className="percentage-row">
        <div className="percentage-label">{percentage}</div>
        <div className="phase-inputs">
          {['R', 'Y', 'B'].map((phase) => {
            const appliedValue = form[`ratioTest${testNum}`].appliedCurrent[percentage][phase];
            const expectedValue = calculateExpectedSecondary(coreRatio.primaryValue, coreRatio.secondaryValue, appliedValue);

            return (
              <div key={`measured-${phase}`} className="phase-column">
                <div className="phase-input">
                  <div className="measured-input-container">
                    <div className="input-group">
                      <input
                        className="input-field small"
                        placeholder="Enter value"
                        value={form[`ratioTest${testNum}`].measuredCurrent[percentage][phase]}
                        onChange={(e) => handleRatioChange(testNum, 'measured', percentage, phase, e.target.value)}
                        disabled={isLoading}
                      />
                      <input
                        className="input-field small error-field"
                        placeholder="Error %"
                        value={form[`ratioTest${testNum}`].measuredCurrent[percentage][`${phase}Error`] ?
                          `${form[`ratioTest${testNum}`].measuredCurrent[percentage][`${phase}Error`]}%` : ''}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ));
  };

  const checklistItems = [
    { key: 'ASS-00', text: 'All CT quantity, rating, type & make are as per approved drawings.' },
    { key: 'ASS-01', text: 'No physical damage to any of the CT.' },
    { key: 'ASS-02', text: 'Inter-panel wiring from CTs to disconnector Terminal blocks in panel is as per approved drawing.' },
    { key: 'ASS-03', text: 'CT secondary star point terminals are properly earthed at disconnector terminal blocks.' },
    { key: 'ASS-04', text: 'CT wiring ferrules are as per drawing.' },
    { key: 'ASS-05', text: 'All CT connections are properly tightened.' }
  ];

  

  return (
    <div className="transformer-ratio-test">
      <span
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px',
            fontWeight: '600',
            color: '#333',
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>

      <div className="ratio-test-card">
        <h1 className="card-title">Ratio Test</h1>

        {Array.from({ length: parseInt(selectedCores) }, (_, i) => i + 1).map((testNum) => (
          <div key={`ratio-test-${testNum}`} className="ratio-test-section">
            <div className="terminal-label">{testNum}S1-{testNum}S2</div>



            <div className="ratio-input-section">
              <div className="ratio-input-container">
                <label htmlFor={`ratioInput-${testNum}`}>Enter Ratio Value for {testNum}S1-{testNum}S2: </label>
                <input
                  id={`ratioInput-${testNum}`}
                  type="text"
                  value={coreRatios[testNum]?.ratioValue || '250/1A'}
                  onChange={(e) => handleCoreRatioChange(testNum, e.target.value)}
                  className="ratio-input"
                  placeholder="Enter ratio (e.g. 250/1A, 500/5A)"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="card-container">
              <div className="card">
                <div className="card-header">
                  Applied Current (Primary)(A)*
                </div>
                <div className="card-content">
                  <div className="percentage-row">
                    <div className="percentage-label">%</div>
                    <div className="phase-inputs">
                      {['R', 'Y', 'B'].map((phase) => (
                        <div key={`applied-header-${phase}`} className="phase-column">
                          <div className="phase-header">{phase}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {renderAppliedCurrentRows(testNum)}
                </div>
              </div>

              <div className="space-gap"></div>

              <div className="card">
                <div className="card-header">
                  Measured Current (Secondary)(A)*
                </div>
                <div className="card-content">
                  <div className="percentage-row">
                    <div className="percentage-label">%</div>
                    <div className="phase-inputs">
                      {['R', 'Y', 'B'].map((phase) => (
                        <div key={`measured-header-${phase}`} className="phase-column">
                          <div className="measured-header-container">
                            <div className="phase-header">{phase}</div>
                            <div className="error-header">Error %</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {renderMeasuredCurrentRows(testNum)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {!shouldShowKneePoint && (
        <div className="checklist-card">
          <div className="card-title">CT Check List</div>
          <table className="checklist-table">
            <thead>
              <tr>
                <th className="col-slno">S.No</th>
                <th className="col-checkpoint">Check Point</th>
                <th className="col-remarks">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {checklistItems.map((item, index) => (
                <tr key={item.key}>
                  <td className="cell-slno">{index + 1}</td>
                  <td className="cell-checkpoint">{item.text}</td>
                  <td className="cell-remarks">
                    <select
                      className="remarks-dropdown"
                      value={checklistData[item.key] || ''}
                      onChange={(e) => handleChecklistChange(item.key, e.target.value)}
                      disabled={isLoading}
                    >
                      <option value="">Select</option>
                      <option value="OK">OK</option>
                      <option value="NOT OK">NOT OK</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="action-buttons">
        <button
          className="btn-back"
          onClick={goBack}
          disabled={isLoading}
        >
          Back
        </button>
        {shouldShowKneePoint ? (
          <button
            className="btn-next"
            onClick={handleNext}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Next"}
          </button>
        ) : (
          <>
            <button
              className="btn-next"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Submit"}
            </button>
            {formSubmitted && (
              <button
                className="btn-download"
                onClick={handleDownloadPDF}
                disabled={!formSubmitted}
              >
                Download Word
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Assitance;












